import { memo, type ReactNode } from "react";
import clsx from "clsx";

interface DialogAwareButtonContainerProps {
    children: ReactNode;
    isDialog?: boolean;
    className?: string;
}

export const DialogAwareButtonContainer = memo(function DialogAwareButtonContainer({
    children,
    isDialog,
    className,
}: DialogAwareButtonContainerProps) {
    const baseClassName = isDialog ? "mt-5" : "";

    return <div className={clsx(baseClassName, className)}>{children}</div>;
});

DialogAwareButtonContainer.displayName = "DialogAwareButtonContainer";
